import React, { Component } from "react";
import { Box, Grid, Typography } from "@mui/material";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import CtBtn from "./CustomTool/CtBtn";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtDtp from "./CustomTool/CtDtp";
import CtTxt from "./CustomTool/CtTxt";
import CtART from "./CustomTool/ResponsiveTable";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";

import {
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { withRouter } from "../HOC/withRouter";
import "./AMCList.css";
import { connect } from "react-redux";
import { fetchSite } from "./API";
import SiteMaster from "./SiteMaster";

class AMCNewEntry extends Component {
  // state = {
  //   formData: {
  //     cmbBranchName: "",
  //     cmbServiceLocation: "",
  //     CmbSiteName: "",
  //     CmbsiteAddress: "",
  //     billingName: "",
  //     billingAddress: "",
  //   },
  //   branchItems: [{ vac_branch: "Branch 1" }, { vac_branch: "Branch 2" }],
  //   serviceLocationItems: [
  //     { vac_service: "Location 1" },
  //     { vac_service: "Location 2" },
  //   ],
  //   dataLoadStatus: true,
  //   ARD: null,
  //   rowsCount: 0,
  //   rowsPerPage: 50,
  // };

  state = {
    formData: {
      cmbBranchName: "",
      cmbServiceLocation: "",
      CmbSiteName: "",
      CmbsiteAddress: "",
      billingName: "",
      billingAddress: "",
    },
    branchItems: [{ vac_branch: "Branch 1" }, { vac_branch: "Branch 2" }],
    SiteName: [],
    serviceLocationItems: [
      { vac_service: "Location 1" },
      { vac_service: "Location 2" },
    ],
    dataLoadStatus: true,
    rowsCount: 0,
    rowsPerPage: 50,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "Top India Elevator : AMC Entry";
    document.getElementById("cmbBranchName").focus();
  }
  //#endregion Component

  //#region handle
  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };
  //#endregion handle

  onKeyDown = (e) => {
    if (e.key === "Enter") {
      const nextCtrlID = e.target.getAttribute("nextctrlid");
      if (!nextCtrlID) return;

      const ctrl = document.getElementById(nextCtrlID);
      if (ctrl) ctrl.focus(); // SAFE
    }
  };

  //region function
  clearInfo = () => {
    this.setState(
      {
        formData: {
          cmbBranchName: "",
          cmbServiceLocation: "",
          CmbSiteName: "",
          CmbsiteAddress: "",
          billingName: "",
          billingAddress: "",
        },
      },
      () => {
        document.getElementById("cmbBranchName")?.focus();
      },
    );
  };

  validationNewEntry = () => {
    const { formData } = this.state;

    if (!formData.cmbBranchName) {
      this.props.toastErrorMsg("Select Branch Name", "cmbBranchName");
      return false;
    }

    // if (!formData.cmbServiceLocation) {
    //   this.props.toastErrorMsg("Select Service Location", "cmbServiceLocation");
    //   return false;
    // }

    if (!formData.CmbSiteName) {
      this.props.toastErrorMsg("Select Site Name", "CmbSiteName");
      return false;
    }

    if (!formData.CmbsiteAddress) {
      this.props.toastErrorMsg("Enter Site Address", "CmbsiteAddress");
      return false;
    }

    if (!formData.billingName) {
      this.props.toastErrorMsg("Enter Billing Name", "billingName");
      return false;
    }

    // if (!formData.billingAddress) {
    //   this.props.toastErrorMsg("Enter Billing Address", "billingAddress");
    //   return false;
    // }

    return true;
  };

  saveEntry = () => {
    if (!this.validationNewEntry()) return;
    this.props.toastMsg("success", "AMC Entry Saved Successfully");
    this.clearInfo();

    // navigate after save if needed
    this.props.navigateTo("AMCRegistration");
  };
  onAddClickSite = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage={<SiteMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getSiteList();
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getSiteList = () => {
    const reqData = {
      Op: "ListSiteMaster",
    };
    fetchSite(reqData)
      .then((res) => {
        this.props.toastMsg("success", "Site List Loaded Successfully");
        let SiteName = res.data.SiteList;

        this.setState({
          SiteName,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    // document.getElementById("txtBranchCode").focus();
  };

  //#endregion handle

  render() {
    return (
      <form>
        {" "}
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          direction="column"
        >
          <Typography fontSize={30} fontWeight={600} textAlign="center">
            AMC Entry
          </Typography>

          <Grid className="amc-entry-form-wrap">
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              direction="row"
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbBranchName"
                  label="Branch Name*"
                  items={this.state.branchItems}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={100}
                  colID="vac_branch"
                  value={this.state.formData.cmbBranchName}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"cmbServiceLocation"}
                />
              </Grid>

              <Grid item>
                <CtCmbEditable
                  id="cmbServiceLocation"
                  label="Service Location"
                  items={this.state.serviceLocationItems}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={100}
                  colID="vac_service"
                  value={this.state.formData.cmbServiceLocation}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"CmbSiteName"}
                />
              </Grid>
              <Grid item>
                <CtCmbEditable
                  id="CmbSiteName"
                  label="Site Name*"
                  items={this.state.SiteName}
                  handleOnChange={this.handleOnChange}
                  width={160}
                  maxLength={100}
                  colID="vac_sitename"
                  value={this.state.formData.CmbSiteName}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"CmbsiteAddress"}
                  bolVisibleOnAddClickIcon={true}
                  onAddClick={this.onAddClickSite}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              marginTop={0}
              direction="row"
            >
              <Grid item>
                <CtTxt
                  id="CmbsiteAddress"
                  label="Site Address*"
                  handleOnChange={this.handleOnChange}
                  width={510}
                  maxLength={100}
                  value={this.state.formData.CmbsiteAddress}
                  onKeyDown={this.props.onKeyDown}
                  disabled={true}
                  defaultAction={this.saveEntry}
                />
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              justifyContent="flex-start"
              direction="row"
              marginTop={0}
            >
              {/* <Grid item>
              <CtTxt
                id="billingName"
                value={this.state.formData.billingName}
                label="Billing Name*"
                handleOnChange={this.handleOnChange}
                maxLength={100}
                // width={250}
                onKeyDown={this.props.onKeyDown}
                nextCtrlID="billingAddress"
              />
            </Grid> */}

              {/* <Grid item>
              <CtTxt
                id="billingAddress"
                value={this.state.formData.billingAddress}
                label="Billing Address*"
                handleOnChange={this.handleOnChange}
                maxLength={100}
                width={300}
                nextCtrlID="btnCreate"
                onKeyDown={this.props.onKeyDown}
                defaultAction={this.saveEntry}
              />
            </Grid> */}
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            justifyContent="center"
            direction="row"
            marginTop={0}
            className="amc-entry-create-btn"
          >
            <Grid item>
              <CtBtn
                id="btnCreate"
                label="Create"
                firstletterBig={false}
                className="secondary-button"
                width={110}
                onClick={this.saveEntry}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <div style={{ textAlign: "right" }}>{this.state.ARD}</div>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(AMCNewEntry))));
